import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular'
import { HttpService } from '../../providers/HttpService';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Generated class for the BusscanActivationComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'busscan-activation',
  templateUrl: 'busscan-activation.html'
})


export class BusscanActivationComponent {

  text: string;
  isRegist: boolean;
  checkedOpen: boolean;
  public content: string = "内容";
  constructor(
    public navParams: NavParams,
    public viewController: ViewController,
    public httpService: HttpService,
    public sanitizer: DomSanitizer
  ) {
    this.text = 'Hello World';
    this.checkedOpen = true; 
    this.getOpenCardInfo(); 
  } 

  getTrueHtml(content: string) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

  getOpenCardInfo() {  
    this.httpService.post('GetBusscanCardInfo').subscribe(res => {
      var result = res.json().result;
      this.content = result;
    });
  }

  closeFilter() {
    this.viewController.dismiss();
  }

  isActivation() {
    this.viewController.dismiss({ activation: this.checkedOpen });
  }

}



// WEBPACK FOOTER //
// ./src/components/busscan-activation/busscan-activation.ts